//import ImageSlider from "../components/ImageSlider";
import { useEffect, useState } from 'react';
import { getPageContent } from '../../services/pages.service';
import { HelmetProvider } from 'react-helmet-async';

const HolisticScience = () => {
    const [htmlElement, setHtmlElement] = useState<any>(null);
    useEffect(() => {
        getPageContent('Holistic Science').then((response) => {
            if (response.status === 200) {
                setHtmlElement(response.data.data?.PageHTML);
            }
        });
    }, []);

    return (
        <>
            <HelmetProvider>
                <title>
                    Homeopathy - Holistic Science
                </title>
                <meta name="keywords" content="holistic health care, Holistic Science, dr in ahmedabad, holistic healing, dr homeo, homeopathy doctor, homeopathic materia medica, natural health care, naturopathic remedies, healing with homeopathy, homoeopathic cases, homeo clinic , holistic health, Arthritis doctor ahmedabad, child homeopathy doctor" />
                <meta name="description" content="Dr Neha Pujara is an efficient homeopathic doctor based in ahmedabad and belives homeopathy as Holistic Science. " />
            </HelmetProvider>
            <div id="content_wrapper_inner">
                <div id="content" className="home">
                    <div>
                        <br />
                        <h1 className='health_care_content'>
                            Holistic Science
                        </h1>
                        <hr />
                        <div>
                            <br />
                            <div className="holisticeScienceImage">
                                <img src={require("../../assets/images/DrSamuelHahnemann.png")} alt="Holistic Science" />
                                <br />
                                <b>Dr Samuel Hahnemann</b>

                            </div>
                            <div className="holisticeScienceContent">
                                <br />
                                {htmlElement && (
                                    <p dangerouslySetInnerHTML={{ __html: htmlElement }}></p>
                                )}

                            </div>

                        </div>
                    </div>
                </div>
            </div >
        </>
    )

};
export default HolisticScience;